import React from 'react'

export const Key = (props) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill={props.fill || 'none'}
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_34_4354)'>
      <path
        d='M17 14H12.659C12.1872 15.3344 11.2589 16.4591 10.038 17.1753C8.81722 17.8914 7.38253 18.1529 5.98754 17.9136C4.59255 17.6743 3.32708 16.9495 2.4148 15.8673C1.50251 14.7852 1.00215 13.4154 1.00215 12C1.00215 10.5846 1.50251 9.21483 2.4148 8.13269C3.32708 7.05055 4.59255 6.32576 5.98754 6.08642C7.38253 5.84708 8.81722 6.1086 10.038 6.82475C11.2589 7.5409 12.1872 8.66558 12.659 10H23V14H21V18H17V14ZM7.00001 14C7.53044 14 8.03915 13.7893 8.41422 13.4142C8.78929 13.0392 9.00001 12.5304 9.00001 12C9.00001 11.4696 8.78929 10.9609 8.41422 10.5858C8.03915 10.2107 7.53044 10 7.00001 10C6.46957 10 5.96087 10.2107 5.58579 10.5858C5.21072 10.9609 5.00001 11.4696 5.00001 12C5.00001 12.5304 5.21072 13.0392 5.58579 13.4142C5.96087 13.7893 6.46957 14 7.00001 14Z'
        fill={props.fill || 'currentColor'}
      />
    </g>
    <defs>
      <clipPath id='clip0_34_4354'>
        <rect width='24' height='24' fill='white' />
      </clipPath>
    </defs>
  </svg>
)
